<script setup>
import { twMerge } from "tailwind-merge";
import { computed } from "vue";

const props = defineProps({
    z: {
        type: Number,
        default: 0,
    },
});

const classes = computed(() => {
    let classes = ["text-sm", "text-gray-500 dark:text-gray-400"];

    return twMerge(classes);
});
</script>
<template>
    <div :class="classes">
        <slot />
    </div>
</template>
